module.exports = __webpack_public_path__ + "static/media/empty-insta.c6d552b8.svg";